import * as React from "react";

export const useReadMore = (limit?: number) => {
  const [expanded, setExpanded] = React.useState(false);

  const toggle = () => setExpanded((prev) => !prev);
  const isVisible = (index: number) => (limit ? expanded || index < limit : true);
  const showToggle = Boolean(limit);

  return { expanded, toggle, isVisible, showToggle };
};
